module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative"
  }, [_c('div', {
    staticClass: "navigation"
  }, [_c('div', {
    staticClass: "position-back"
  }, [_c('div', {
    staticClass: "button is-small",
    on: {
      "click": function($event) {
        return _vm.$emit('prev')
      }
    }
  }, [_vm._m(0), _c('span', [_vm._v("Previous step")])])])]), _vm._m(1), _c('div', {
    staticClass: "control is-medium is-expanded mt-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    ref: "inputcoin",
    staticClass: "input is-medium",
    attrs: {
      "id": "local-coin-search",
      "type": "text",
      "placeholder": "Search for your coin / token"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _c('br'), (_vm.isLoading) ? [_c('span', [_vm._v("Loading...")]), _c('br')] : _vm._e(), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile"
  }, [_vm._l((_vm.firstList), function(o) {
    return _c('div', {
      staticClass: "column box-container is-half-desktop is-full-tablet is-full-mobile"
    }, [_c('div', {
      staticClass: "element-box-container",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.select(o)
        }
      }
    }, [(o.top == 1) ? _c('strong', {
      staticClass: "tag hint--bottom top",
      attrs: {
        "aria-label": "Just added"
      }
    }, [_vm._v("New")]) : _vm._e(), _c('img', {
      attrs: {
        "src": o.logo,
        "alt": o.symbol + ' icon'
      }
    }), _c('div', [_c('div', {
      staticClass: "flex-1 has-text-left"
    }, [_c('span', {
      staticClass: "name"
    }, [_c('b', [_vm._v(_vm._s(o.name) + " ")])]), _c('span', {
      staticClass: "symbol"
    }, [_vm._v("(" + _vm._s(o.symbol) + ")")])]), (o.chains.length > 0) ? _c('div', {
      staticClass: "extra-info has-text-left"
    }, _vm._l((o.chains), function(u) {
      return (o.chains.length > 0) ? _c('div', {
        staticClass: "tag network hint--bottom hint--medium",
        attrs: {
          "aria-label": 'Supported through the ' + u.name + ' (' + u.network + ') network'
        }
      }, [_vm._v(_vm._s(u.token_standard || u.network))]) : _vm._e()
    }), 0) : _vm._e()])])])
  }), _vm._l((_vm.shadowList), function(o) {
    return _c('div', {
      staticClass: "column box-container is-half-desktop is-full-tablet is-full-mobile"
    }, [_c('div', {
      staticClass: "element-box-container",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.select(o)
        }
      }
    }, [(o.top == 1) ? _c('strong', {
      staticClass: "tag hint--bottom top",
      attrs: {
        "aria-label": "Just added"
      }
    }, [_vm._v("New")]) : _vm._e(), _c('img', {
      attrs: {
        "src": o.logo,
        "alt": o.symbol + ' icon'
      }
    }), _c('div', [_c('div', {
      staticClass: "flex-1 has-text-left"
    }, [_c('span', {
      staticClass: "name"
    }, [_c('b', [_vm._v(_vm._s(o.name) + " ")])]), _c('span', {
      staticClass: "symbol"
    }, [_vm._v("(" + _vm._s(o.symbol) + ")")])]), (o.chains.length > 0) ? _c('div', {
      staticClass: "extra-info has-text-left"
    }, _vm._l((o.chains), function(u) {
      return (o.chains.length > 0) ? _c('div', {
        staticClass: "tag network hint--bottom hint--medium",
        attrs: {
          "aria-label": 'Supported through the ' + u.name + ' (' + u.network + ') network'
        }
      }, [_vm._v(_vm._s(u.token_standard || u.network))]) : _vm._e()
    }), 0) : _vm._e()])])])
  })], 2)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-title"
  }, [_c('span', [_vm._v("Select your coin or token")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28225ec7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/get_started/c_step_coin.vue
// module id = 367
// module chunks = 1